import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const BG = "https://images.unsplash.com/photo-1608114759160-ad0b1bac35b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxzYW5kJTIwdGV4dHVyZSUyMGxpZ2h0JTIwc2hhZG93fGVufDB8fHx8MTc4MjYzMTQ3MHww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u?.role === "admin" ? "/admin/users" : "/browse");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#C85A44]/40 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="overline text-white/80 mb-3">Welcome back</p>
          <h2 className="font-serif-display text-4xl leading-tight">
            Pick up where you left off — your next conversation is waiting.
          </h2>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 md:px-12 py-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <p className="overline mb-3">Sign in</p>
          <h1 className="font-serif-display text-4xl mb-10 leading-tight">Welcome back.</h1>
          {error && (
            <div data-testid="login-error" className="mb-6 rounded-xl bg-[#FAE5E0] border border-[#9C3A3A]/20 text-[#9C3A3A] px-4 py-3 text-sm">
              {error}
            </div>
          )}
          <label className="block text-sm mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="w-full rounded-xl border border-[#E2DCD0] bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C85A44]/30 focus:border-[#C85A44] transition mb-5"
            placeholder="you@example.com"
          />
          <label className="block text-sm mb-2">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="w-full rounded-xl border border-[#E2DCD0] bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C85A44]/30 focus:border-[#C85A44] transition mb-8"
            placeholder="••••••••"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full rounded-full bg-[#C85A44] hover:bg-[#A84A36] disabled:opacity-60 text-white px-6 py-3.5 text-sm font-medium transition"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="mt-6 text-sm text-[#8C857B] text-center">
            New here?{" "}
            <Link to="/register" data-testid="login-to-register" className="text-[#C85A44] hover:underline">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
